// extracted by mini-css-extract-plugin
export default {"toggle":"SidebarToggle_toggle__vTS70"};